import superMeta from '../_ALG_CAT/metaAlgCatNode.mjs'

export default {
    ...superMeta,
    algNodeType: 'BFDATAFLOW',
    algType: 'SUMMARY',
    name: '子流程',
    type: 'BF_DATAFLOW',
}
